import mockPageResolutionService, { setPages, buildPageResolutionService } from './mockPageService.mjs';
import mockAnswerService from './mockAnswerService.mjs';
import mockContactService from './mockContactService.mjs';
import mockAppointmentService from './mockAppointmentService.mjs';
import mockNoteService from './mockNoteService.mjs';
import mockEmployeeService from './mockEmployeeLoginService.mjs';
import { mockConversationTestService } from './mockConversationTestService.mjs';
import mockUserService from './mockUserService.mjs';

const mockModeOptionsCacheKey = 'neuroMockModeOptions';

const installMocks = (opts = {}) => {
  console.log('Attempting to install mock services.');

  if (!window.ignite) {
    throw new Error('ignite global is not available');
  } else {
    window.ignite.isUsingMockService = true;
  }

  const optsForMock = getMockModeAppOptions();
  const isBranchGuide = optsForMock.isBranchGuide || opts.isBranchGuide;
  const isBusinessGuide = optsForMock.isBusinessGuide || false;

  const pages = opts.pages || null;
  const guideDelivery = isBranchGuide ? 'branch' : 'online';
  const guideType = isBusinessGuide
    ? 'business'
    : optsForMock.guideDelivery || 'consumer';

  if (!pages && !mockPageResolutionService.ready === true) {
    throw new Error(
      'cannot install mock services as mockPageService is not ready and no pages array has been provided'
    );
  }

  if (pages) {
    setPages(pages);
  }

  window.ignite.answerService = mockAnswerService;
  window.ignite.pageResolutionService = buildPageResolutionService({
    guideDelivery,
    guideType,
    optsForMock,
  });
  window.ignite.noteService = mockNoteService;
  window.ignite.employeeLoginService = mockEmployeeService;
  window.ignite.contactService = mockContactService;
  window.ignite.appointmentService = mockAppointmentService;
  window.ignite.userService = mockUserService;
  window.ignite.appointmentSettings = {};
  window.ignite.conversationTestService = {
    loadGuideConversationForTesting: () =>
      mockConversationTestService.loadGuideConversationForTesting(pages),
  };
  console.log('Mock services successfully installed.');
};

const getMockModeAppOptions = () => {
  const options = window.sessionStorage.getItem(mockModeOptionsCacheKey);
  return options
    ? {
      ...JSON.parse(options),
      isMockMode: true,
    }
    : {};
};

const setMockModeAppOptions = ({
  isBranchGuide,
  isBusinessGuide,
  isRemoteSession,
}) => {
  window.sessionStorage.setItem(
    mockModeOptionsCacheKey,
    JSON.stringify({
      isBranchGuide: isBranchGuide || false,
      isRemoteSession: isRemoteSession || false,
      guideType: isBusinessGuide ? 'business' : 'consumer',
    })
  );
};

export * from './mockUtil.mjs';
export {
  installMocks as default,
  getMockModeAppOptions,
  setMockModeAppOptions,
};
